import { Async } from '@client/new/helpers/types';
import {
  ExerciseSuggestion,
  useExerciseSuggestionsAsync,
} from '@client/new/helpers/exercise-suggestions';

export const useWorkoutEditorExerciseSuggestionsModel = (
  query: string,
): Async<ExerciseSuggestion[]> => useExerciseSuggestionsAsync(query);
